export const HEADER_HEIGHT = 24;
